import script from "./DashboardTextBlock.vue?vue&type=script&lang=ts"
export * from "./DashboardTextBlock.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__